import script from "./ReplacementComparison.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReplacementComparison.vue?vue&type=script&setup=true&lang=ts"

import "./ReplacementComparison.vue?vue&type=style&index=0&id=52b3094b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52b3094b"]])

export default __exports__